import apiClient from './api-client';

// Re-export the apiClient methods
export default apiClient;
